var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 134,
    viewBox: "0 0 136 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_20670)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M26.6642 52.3013C17.2768 58.2447 10.3986 68.4459 10.0148 79.4317C9.63102 90.4176 16.5093 101.665 27.0775 105.182C32.6126 107.027 38.62 106.751 44.465 106.446C52.3469 106.039 60.2436 105.647 68.1255 105.24C70.7085 105.109 73.3801 104.949 75.6679 103.743C80.9225 100.953 81.882 94.065 82.1772 88.1942C82.6495 78.8505 82.9594 69.1579 79.3875 60.4826C76.6421 53.7981 70.989 47.7239 63.8155 45.6749C60.3469 44.6868 56.5683 44.9919 52.9963 45.0355C48.6569 45.0937 44.3174 45.6168 40.1107 46.6631C35.3727 47.8256 30.7971 49.6856 26.6642 52.3013Z",
    fill: "#18499A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.074 87.4531H64.3027V93.5709H66.074V87.4531Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.074 99.2963H64.3027V105.414H66.074V99.2963Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3097 95.5617H68.0957V97.3055H74.3097V95.5617Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2804 95.5617H56.0664V97.3055H62.2804V95.5617Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.019 46.9247H117.248V51.9526H119.019V46.9247Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.019 56.6754H117.248V61.7033H119.019V56.6754Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.646 53.4493H120.539V55.1931H125.646V53.4493Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.742 53.4493H110.635V55.1931H115.742V53.4493Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6457 10.3633H47.8745V15.3912H49.6457V10.3633Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6457 20.0994H47.8745V25.1273H49.6457V20.0994Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2584 16.8734H51.1514V18.6172H56.2584V16.8734Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3692 16.8734H41.2622V18.6172H46.3692V16.8734Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1219 98.9476C22.0887 98.9476 17.9854 94.9223 17.9854 89.9525C17.9854 84.9828 22.0739 80.9575 27.1219 80.9575C32.1699 80.9575 36.2584 84.9828 36.2584 89.9525C36.2584 94.9223 32.1699 98.9476 27.1219 98.9476ZM27.1219 82.7158C23.0628 82.7158 19.7566 85.9709 19.7566 89.9671C19.7566 93.9633 23.0628 97.2183 27.1219 97.2183C31.1809 97.2183 34.4872 93.9633 34.4872 89.9671C34.4872 85.9709 31.1809 82.7158 27.1219 82.7158Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7418 123.637H10.502V113.566C10.502 104.528 17.9706 97.1893 27.1366 97.1893C31.5647 97.1893 35.7418 98.904 38.871 101.999C42.0149 105.094 43.7418 109.192 43.7418 113.552V123.637ZM12.2732 121.893H41.9706V113.566C41.9706 109.672 40.4208 106.01 37.6163 103.249C34.8119 100.473 31.0924 98.9476 27.1366 98.9476C18.9448 98.9476 12.2879 105.501 12.2879 113.566V121.893H12.2732Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7087 113.319H16.9375V122.765H18.7087V113.319Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3064 113.319H35.5352V122.765H37.3064V113.319Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.299 98.9476C98.2659 98.9476 94.1626 94.9223 94.1626 89.9525C94.1626 84.9828 98.2512 80.9575 103.299 80.9575C108.332 80.9575 112.436 84.9828 112.436 89.9525C112.436 94.9223 108.332 98.9476 103.299 98.9476ZM103.299 82.7158C99.2401 82.7158 95.9338 85.9709 95.9338 89.9671C95.9338 93.9633 99.2401 97.2183 103.299 97.2183C107.358 97.2183 110.664 93.9633 110.664 89.9671C110.664 85.9709 107.358 82.7158 103.299 82.7158Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.904 123.637H86.6792V113.566C86.6792 104.528 94.1331 97.1893 103.299 97.1893C107.727 97.1893 111.904 98.904 115.033 101.999C118.177 105.094 119.904 109.192 119.904 113.552V123.637ZM88.4504 121.893H118.148V113.566C118.148 109.672 116.598 106.01 113.794 103.249C110.989 100.473 107.27 98.9476 103.314 98.9476C95.122 98.9476 88.4652 105.501 88.4652 113.566V121.893H88.4504Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.886 113.319H93.1147V122.765H94.886V113.319Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.469 113.319H111.698V122.765H113.469V113.319Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9888 86.901V74.6654H33.3062V35.1396L94.5312 35.0815V36.8253L35.0774 36.8834V72.9216H40.76V82.3671L49.4242 72.9216H81.4833L90.3246 82.3962V72.9216H95.2988V43.0157H97.07V74.6654H92.0958V86.8719L80.701 74.6654H50.2213L38.9888 86.901Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4464 62.7205L42.2656 61.4272L54.5756 50.6302L61.5276 55.8035L76.5387 43.7423L80.2435 47.5641L99.1512 30.6494L100.332 31.9427L80.1549 50.0054L76.3911 46.1255L61.5719 58.0268L54.6641 52.8826L43.4464 62.7205Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8857 65.5687H48.7603V67.3124H66.8857V65.5687Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3394 65.5687H71.2988V67.3124H74.3394V65.5687Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.502 67.3125H78.4282V65.5687H88.7308V48.436H90.502V67.3125Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.727 31.3032L97.085 28.7021L100.701 27.743L104.303 26.7985L103.343 30.3442L102.369 33.9044L99.727 31.3032Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_20670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 114,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2);
export default __webpack_public_path__ + "static/media/b2.cbd1644aa3079199283d90947bb9d25f.svg";
export { ForwardRef as ReactComponent };